import { toolAuthLabel } from './toolFormUtils';
import { relativeTime } from '../../utils/relativeTime';

export function buildUnifiedToolRows({ connectors = [], mcpServers = [], nativeTools = [], isAdmin = false }) {
  const rows = [];

  connectors.forEach((c) => {
    rows.push({
      key: `http-${c.id}`,
      rowType: 'http',
      id: c.id,
      name: c.name,
      url: c.base_url,
      type: 'HTTP',
      auth: toolAuthLabel(c.auth_type),
      toolCount: c.tool_count ?? 0,
      status: 'connected',
      statusLabel: 'Connected',
      linkedCount: c.linked_assistant_count ?? 0,
      linkedAssistantIds: c.linked_assistant_ids ?? [],
      enabled: true,
      syncError: null,
      toolsSyncedAt: null,
      raw: c,
    });
  });

  mcpServers.forEach((s) => {
    let status = 'connected';
    let statusLabel = 'Connected';
    if (s.enabled === false) {
      status = 'disabled';
      statusLabel = 'Disabled';
    } else if (s.sync_error) {
      status = 'error';
      statusLabel = 'Error';
    } else if (!s.tools_synced_at) {
      status = 'pending';
      statusLabel = 'Pending sync';
    } else if (s.auth_type === 'oauth_authorization_code') {
      statusLabel = 'Connected';
    }

    rows.push({
      key: `mcp-${s.id}`,
      rowType: 'mcp',
      id: s.id,
      name: s.name,
      url: s.url,
      type: 'MCP',
      auth: toolAuthLabel(s.auth_type),
      toolCount: s.tool_count ?? 0,
      status,
      statusLabel,
      linkedCount: s.linked_assistant_count ?? 0,
      linkedAssistantIds: s.linked_assistant_ids ?? [],
      enabled: s.enabled !== false,
      syncError: s.sync_error,
      toolsSyncedAt: s.tools_synced_at,
      raw: s,
    });
  });

  if (isAdmin) {
    nativeTools.forEach((t) => {
      rows.push({
        key: `native-${t.qualified_name || t.name}`,
        rowType: 'native',
        id: t.qualified_name || t.name,
        name: t.qualified_name || t.name,
        url: '',
        type: 'Native',
        auth: 'Built-in',
        toolCount: 1,
        status: 'connected',
        statusLabel: 'Always on',
        linkedCount: null,
        enabled: true,
        raw: t,
      });
    });
  }

  return rows.sort((a, b) => String(a.name).localeCompare(String(b.name)));
}

export function formatSyncTime(iso) {
  if (!iso) return null;
  try {
    return relativeTime(iso);
  } catch {
    return null;
  }
}

export function filterToolRows(rows, query) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return rows;
  return rows.filter(
    (r) =>
      r.name?.toLowerCase().includes(q)
      || r.url?.toLowerCase().includes(q)
      || r.type?.toLowerCase().includes(q),
  );
}
